export default __webpack_public_path__ + "static/media/rummo-for-business_1.64cc08f8.svg";